<mat-toolbar class="navbar" color="primary">
  <mat-icon class="logo-icon" aria-hidden="false" svgIcon="logo"></mat-icon>
  <span class="navbar-brand ml-3">CAREKARTE Pivot CCJ Console</span>
  <mat-icon class="pivot-icon" aria-hidden="false" svgIcon="pivot_header"></mat-icon>
  <span class="navbar-spacer"></span>
  <div *ngIf="isLoggedIn" class="setting-box">
    <ng-container class="setting-box" #menuContainer>
      <span class="btn-setting" (mouseenter)="onHover()" (mouseleave)="onLeave()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">{{ fullName }}</span>
      <span> ｜ </span>
      <span (click)="onLogout()" class="btn-logout">ログアウト</span>
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger.elementRef"
        [cdkConnectedOverlayOpen]="isOpenOtherMenu"
        [cdkConnectedOverlayHasBackdrop]="false"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }]"
        (backdropClick)="backdropClick()">
        <div class="header-menu" (mouseenter)="onHover()" (mouseleave)="onLeave()">
          <div (click)="goAccountInformation()" class="header-menu-btn d-flex align-items-center justify-content-center p-2">
            <div>アカウント情報</div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</mat-toolbar>